import { Link } from "react-router-dom";

const Aside = ()=>{
    return (
      <aside>
        <label class="fas fa-close cursor-pointer aside-close" htmlFor="aside-toggle-checkbox"/>
        <span className="aside-title">Dashboard</span>
        <div className="sidebar">
          <ul className="nav-sidebar">
            <li className="nav-item active d-none">
              <Link to="/dashboard" className="nav-link">
                <i className="nav-icon fas fa-tachometer-alt"></i>
                <p>Dashboard</p>
              </Link>
            </li>
              {/* <li className="nav-item active">
                <Link to="/id-cards" className="nav-link">
                  <i className="nav-icon fas fa-id-card"></i>
                  <p>Id Cards</p>
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to="/equipment-certificates" className="nav-link">
                  <i className="nav-icon fas fa-certificate"></i>
                  <p>Equipment Certificates</p>
                </Link>
              </li>
            {/* <li className="nav-item">
              <Link to="/users" className="nav-link">
                <i className="nav-icon fas fa-users"></i>
                <p>Users</p>
              </Link>
            </li> */}
          </ul>
        </div>
      </aside>
    );
}

export default Aside;